import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleAutoLogin } from '@backrs_ui/common-ui';

import {
  selectIsSharedAccountSessionActive,
  selectSharedAccountSessionToken,
} from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedAccountSession';
import type { RootState } from '@backrs_ui/grow-ui/src/redux/store';
import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const fetchUserViaAutoLogin = createAsyncThunk(
  'user/fetchUserViaAutoLogin',
  async (_, { rejectWithValue, getState }) => {
    try {
      if (!ENVIRONMENT_URL) {
        return rejectWithValue('No environment URL found');
      }

      const state = getState() as RootState;
      const isSharedAccountSessionActive = selectIsSharedAccountSessionActive(state);
      const sharedAccountSessionToken = selectSharedAccountSessionToken(state);

      const accessToken =
        isSharedAccountSessionActive && sharedAccountSessionToken
          ? sharedAccountSessionToken
          : getBackrsToken();

      if (!accessToken) {
        return null;
      }

      const backrsUser = await handleAutoLogin(accessToken, ENVIRONMENT_URL);

      if (!backrsUser) {
        return null;
      }

      return backrsUser;
    } catch (error) {
      return rejectWithValue(`Failed to fetch career questions with error: ${error}`);
    }
  },
);
